<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>服务管理</el-breadcrumb-item>
      <el-breadcrumb-item>请求详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="pn-order" v-if="serviceQuest.id && fromOngoingList">
      <el-link
        :underline="false"
        :disabled="!preAndNextOrderInfo.pre_order_info"
        @click="gotoDetail(preAndNextOrderInfo.pre_order_info.split(':')[0])"
        ><i class="el-icon-d-arrow-left el-icon--right"></i> 上一条
        {{ preAndNextOrderInfo.pre_order_info.split(':')[1] }}</el-link
      >
      <el-link
        :underline="false"
        :disabled="!preAndNextOrderInfo.next_order_info"
        @click="gotoDetail(preAndNextOrderInfo.next_order_info.split(':')[0])"
        >下一条 {{ preAndNextOrderInfo.next_order_info.split(':')[1]
        }}<i class="el-icon-d-arrow-right el-icon--right"></i
      ></el-link>
    </div>

    <div class="panel mt-20 infos-wrapper" :class="{ 'pt-50': canClose }">
      <div v-if="serviceQuest.id" class="infos">
        <dl>
          <dt>NCR编号</dt>
          <dd>
            {{ serviceQuest.number }}
            <span
              class="text-primary pointer ml-10"
              v-permission="Auth.serviceQuestEvaluate"
              v-if="serviceQuest.status == 2"
              @click="editNumber"
              >编辑</span
            >
          </dd>
        </dl>
        <dl style="align-items: center">
          <dt>请求状态</dt>
          <dd class="flex-row">
            <span
              v-if="
                serviceQuest.approval_id > 0 && serviceQuest.approve_index == 0
              "
              class="status-tag-border info"
            >
              审批中
            </span>
            <span v-else class="status-tag-border info">
              {{ ServiceQuestStatusMap[serviceQuest.status] }}
            </span>
          </dd>
        </dl>
        <dl
          v-if="
            serviceQuest.customer.important == 2 && serviceQuest.category == 1
          "
        >
          <dt>紧急程度</dt>
          <dd class="flex-row">
            <span class="level-info text-danger"> 紧急 </span>
          </dd>
        </dl>
        <dl>
          <dt>创建日期</dt>
          <dd>
            {{ formatTime(serviceQuest.created_at, 'YYYY/M/D') }}
          </dd>
        </dl>
        <dl>
          <dt>中间商</dt>
          <dd>
            <customer-link
              class="font-12"
              :customer="serviceQuest.dealer"
            ></customer-link>
            {{
              serviceQuest.quest_dealer_contact.name
                ? `（${serviceQuest.quest_dealer_contact.name} ${serviceQuest.quest_dealer_contact.mobile}）`
                : ''
            }}
          </dd>
        </dl>
        <dl>
          <dt>最终客户</dt>
          <dd>
            <customer-link :customer="serviceQuest.customer"></customer-link>
            <span class="text-gray" v-if="serviceQuest.customer.sap_code"
              >（{{ serviceQuest.customer.sap_code }}）</span
            >

            <span v-if="serviceQuest.customer_contact_id"
              >（{{ serviceQuest.customer_contact.name }}
              {{ serviceQuest.customer_contact.mobile }}）
            </span>
            <span
              v-else-if="
                serviceQuest.customer_user.name &&
                !serviceQuest.customer_user.dealer_id
              "
              >（{{ serviceQuest.customer_user.name }}
              {{ serviceQuest.customer_user.mobile }}）
            </span>
            <span
              class="text-primary ml-5"
              v-if="
                !isadealer &&
                !serviceQuest.customer.sap_code &&
                serviceQuest.customer.id
              "
              ><el-tag type="danger" size="mini">未认证客户</el-tag>
              <span
                class="pointer"
                @click="
                  sapCodeCustomer.id = serviceQuest.customer_id
                  sapCodeCustomer.name = serviceQuest.customer.name
                  sapCodeVisible = true
                "
                >去认证</span
              ></span
            >
          </dd>
        </dl>
        <dl>
          <dt>直销销售</dt>
          <dd v-if="serviceQuest.customer.platform_user_id">
            {{
              serviceQuest.customer.platform_user.name +
              '（' +
              serviceQuest.customer.platform_user.phone_number +
              '）'
            }}
            <span class="text-gray">{{
              serviceQuest.customer.platform_user.status != 1 ? '已禁用' : ''
            }}</span>
          </dd>
        </dl>
        <dl>
          <dt>电话销售</dt>
          <dd v-if="serviceQuest.customer.telesale_id">
            {{
              serviceQuest.customer.telesale.name +
              '（' +
              serviceQuest.customer.telesale.phone_number +
              '）'
            }}
            <span class="text-gray">{{
              serviceQuest.customer.telesale.status != 1 ? '已禁用' : ''
            }}</span>
          </dd>
        </dl>
        <dl>
          <dt>新品销售</dt>
          <dd v-if="serviceQuest.customer.new_product_sale_id">
            {{
              serviceQuest.customer.new_product_sale.name +
              '（' +
              serviceQuest.customer.new_product_sale.phone_number +
              '）'
            }}
          </dd>
        </dl>
        <dl>
          <dt>客户设备</dt>
          <dd>
            <span>{{ serviceQuest.device.serial_number }}，</span>
            <span>{{ serviceQuest.device.equipment_number }}，</span>
            <span>
              {{
                serviceQuest.device.item_category.whole_name.replace(/,/g, '-')
              }}，
            </span>
            <span>{{ serviceQuest.device.machine_type }}，</span>
            <span
              >{{
                serviceQuest.device.product_application
                  ? serviceQuest.device.product_application.join(' / ')
                  : ''
              }}，</span
            >
            <span
              >{{ serviceQuest.device.running_time }}
              <span v-if="serviceQuest.device.running_time_updated_at"
                >（运行时长更新于
                {{ serviceQuest.device.running_time_updated_at }}）</span
              ></span
            >
          </dd>
        </dl>
        <dl>
          <dt>设备地址</dt>
          <dd>
            <template v-if="serviceQuest.device.address.id">
              <span
                >{{ CodeToText[serviceQuest.device.address.province] }}，{{
                  CodeToText[serviceQuest.device.address.city]
                }}，{{ CodeToText[serviceQuest.device.address.county] }}，{{
                  serviceQuest.device.address.detail
                }}</span
              >
              <span
                class="text-primary pointer ml-10"
                @click="showDeviceAddressFormer"
                >编辑</span
              >
            </template>
          </dd>
        </dl>
        <dl>
          <dt>报修人</dt>
          <dd v-if="serviceQuest.proposer_name">
            {{ serviceQuest.proposer_name }}（{{
              serviceQuest.proposer_mobile
            }}）
          </dd>
          <dd v-else-if="serviceQuest.customer_user.name">
            {{ serviceQuest.customer_user.name }}（{{
              serviceQuest.customer_user.mobile
            }}）
          </dd>
        </dl>
        <dl>
          <dt>需求类型</dt>
          <dd>
            {{ serviceQuest.cmm_category }}
          </dd>
        </dl>
        <dl>
          <dt>问题分类</dt>
          <dd>
            {{ serviceQuest.sub_category }}
          </dd>
        </dl>
        <dl>
          <dt>详细描述</dt>
          <dd>
            <div v-html="serviceQuest.desc"></div>
            <div
              class="desc-img"
              v-if="serviceQuest.desc_imgs || serviceQuest.desc_videos"
            >
              <auth-img
                tag="el-image"
                v-if="serviceQuest.desc_imgs"
                v-for="item in serviceQuest.desc_imgs"
                :preview-src-list="serviceQuest.desc_imgs"
                :key="item"
                :src="item"
                fit="cover"
                style="width: 40px; height: 40px; margin-right: 4px"
              ></auth-img>
              <div
                v-if="serviceQuest.desc_videos"
                class="video-container"
                v-for="item in serviceQuest.desc_videos"
                @click="
                  videoPlay(item.replaceAll('#', 'hashtag') + '?t=' + FileToken)
                "
              >
                <auth-img
                  tag="video"
                  width="40"
                  height="40"
                  :src="item"
                ></auth-img>
                <div>
                  <i class="el-icon-video-play"></i>
                </div>
              </div>
            </div>
          </dd>
        </dl>
        <dl v-if="shareUrl">
          <dt>分享链接</dt>
          <dd v-if="!isadealer">
            <span class="text-primary pointer">{{ shareUrl }}</span>
            <span
              class="pointer ml-10"
              v-clipboard="shareUrl"
              @success="copySuccess('sqCopyTip')"
              >{{ sqCopyTip }}</span
            >
          </dd>
        </dl>
        <template v-if="serviceQuest.category == 1">
          <dl v-if="serviceQuest.mode <= 2">
            <dt>HS2 申明</dt>
            <dd
              v-if="serviceQuest.hs2"
              class="text-primary pointer"
              @click="showHS2 = true"
            >
              点击查看
            </dd>
            <dd v-else-if="!isadealer && serviceQuest.status <= 2">
              在线填写链接：<span
                class="text-primary pointer"
                @click="getHS2MPUrl"
                >{{ mp_hs_link || '点击获取' }}</span
              >
              <span
                class="pointer ml-10"
                v-clipboard="mp_hs_link"
                @success="copySuccess('hs2CopyTip')"
                v-if="mp_hs_link"
                >{{ hs2CopyTip }}</span
              >
            </dd>
          </dl>
          <dl v-if="serviceQuest.mode <= 2">
            <dt>物流信息</dt>
            <dd v-if="serviceQuest.logistics_number">
              {{ serviceQuest.logistics_number }}（{{
                serviceQuest.logistics_company
              }}）
            </dd>
            <dd v-else-if="!isadealer && serviceQuest.status <= 2">
              在线填写链接：<span
                class="text-primary pointer"
                @click="getLogisticsMPUrl"
                >{{ mp_logistics_link || '点击获取' }}</span
              >
              <span
                class="pointer ml-10"
                v-clipboard="mp_logistics_link"
                @success="copySuccess('logisticsCopyTip')"
                v-if="mp_logistics_link"
                >{{ logisticsCopyTip }}</span
              >
            </dd>
          </dl>
        </template>
        <template
          v-if="
            serviceQuest.category == 1 && serviceQuest.service_quest_flow_id
          "
        >
          <dl>
            <dt class="text-black font-bold mt-10">评估方案</dt>
          </dl>
          <dl>
            <dt>处理方式</dt>
            <dd>
              {{ serviceQuest.flow.name }}
            </dd>
          </dl>
          <dl v-if="serviceQuest.flow.relative_fileds.includes(4)">
            <dt>是否上门提货</dt>
            <dd>
              {{ serviceQuest.pick_up == 1 ? '是' : '否' }}
            </dd>
          </dl>
          <dl v-if="serviceQuest.flow.relative_fileds.includes(1)">
            <dt>接收地点</dt>
            <dd v-if="serviceQuest.repair_dealer_id">
              {{ serviceQuest.repair_dealer_name }}
            </dd>
          </dl>
          <dl>
            <dt>OEM厂商</dt>
            <dd v-if="serviceQuest.oem_id > 0">
              <div>
                {{ serviceQuest.oem.name }}
                <span class="text-gray" v-if="serviceQuest.oem_sap_code"
                  >（{{ serviceQuest.oem_sap_code }}）</span
                >
                <span v-if="serviceQuest.dealer_contact.name"
                  >（{{ serviceQuest.dealer_contact.name }}
                  {{ serviceQuest.dealer_contact.mobile }}）
                </span>
              </div>
            </dd>
          </dl>
          <dl>
            <dt>设备号</dt>
            <dd>
              {{ serviceQuest.product_number }}
            </dd>
          </dl>
          <dl>
            <dt>发货日期</dt>
            <dd>
              {{ serviceQuest.delivery_date }}
            </dd>
          </dl>
          <dl>
            <dt>保修类型</dt>
            <dd>
              {{ serviceQuest.warranty_type }}
            </dd>
          </dl>
          <!-- <dl>
            <dt>FSE现场检测</dt>
            <dd>
              {{ serviceQuest.fse_testing }}
            </dd>
          </dl> -->
          <dl>
            <dt>新品销售</dt>
            <dd>
              {{ serviceQuest.new_product_sale.name }}
            </dd>
          </dl>
          <dl>
            <dt>生产工厂</dt>
            <dd>
              {{ serviceQuest.factory }}
            </dd>
          </dl>
          <template v-if="getFormDataParam('service_order_no')">
            <dl>
              <dt style="width: 120px">Service Order no.</dt>
              <dd>
                {{
                  getFormDataParam('service_order_no').service_order_no.value
                }}
              </dd>
            </dl>
            <dl v-if="getFormDataParam('service_order_no').notification_no">
              <dt style="width: 120px">Notification no.</dt>
              <dd>
                {{ getFormDataParam('service_order_no').notification_no.value }}
              </dd>
            </dl>
          </template>
        </template>
        <!-- <template
          v-if="serviceQuest.category == 1 && serviceQuest.comment_info"
        >
          <dl>
            <dt class="text-black font-bold mt-10">服务评价</dt>
          </dl>
          <dl>
            <dt>评价人</dt>
            <dd>
              {{ serviceQuest.comment_info.user_name }}（{{
                serviceQuest.comment_info.user_mobile
              }}）
            </dd>
          </dl>
          <dl>
            <dt>总体满意度</dt>
            <dd>{{ serviceQuest.comment_info.rate }}星（满分10星）</dd>
          </dl>
          <dl>
            <dt>技术能力</dt>
            <dd>{{ serviceQuest.comment_info.rate1 }}星（满分10星）</dd>
          </dl>
          <dl>
            <dt>沟通能力</dt>
            <dd>{{ serviceQuest.comment_info.rate2 }}星（满分10星）</dd>
          </dl>
          <dl>
            <dt>讲解及建议</dt>
            <dd>{{ serviceQuest.comment_info.rate3 }}星（满分10星）</dd>
          </dl>
          <dl>
            <dt>报告质量</dt>
            <dd>{{ serviceQuest.comment_info.rate4 }}星（满分10星）</dd>
          </dl>
          <dl>
            <dt>服务水平</dt>
            <dd v-if="serviceQuest.comment_info.rate5 == 1">领先平均水平</dd>
            <dd v-else-if="serviceQuest.comment_info.rate5 == 2">
              低于平均水平
            </dd>
            <dd v-else-if="serviceQuest.comment_info.rate5 == 3">
              处于平均水平
            </dd>
          </dl>
          <dl>
            <dt>其他建议</dt>
            <dd>
              {{ serviceQuest.comment_info.desc || '无' }}
            </dd>
          </dl>
        </template> -->
        <template
          v-if="
            serviceQuest.category == 2 && serviceQuest.service_quest_flow_id
          "
        >
          <dl>
            <dt class="text-black font-bold mt-10">评估方案</dt>
          </dl>
          <dl>
            <dt>收购价格</dt>
            <dd>{{ serviceQuest.quoted_price }}元</dd>
          </dl>
          <dl>
            <dt>维修成本</dt>
            <dd>{{ serviceQuest.maintenance_cost }}元</dd>
          </dl>
        </template>
        <!-- <div
          @click="unfold = !unfold"
          class="unfold"
          v-if="serviceQuest.mode_status > 1 || serviceQuest.status == 100"
        >
          {{ unfold ? '收起' : '展开更多信息' }}
        </div> -->
      </div>
      <div v-show="canClose" class="btn-option">
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-edit"
          @click="startServiceQuestFormer"
          v-permission="Auth.serviceQuestUpdate"
          >编辑
        </el-button>
        <template v-if="flowIndex > 1">
          <el-button
            class="mt-10 ml-0"
            size="mini"
            type="primary"
            plain
            icon="el-icon-refresh-left"
            v-permission="Auth.serviceQuestUpdate"
            @click="startRollbackFormer"
            >回滚
          </el-button>
        </template>
        <el-button
          class="mt-10 ml-0"
          size="mini"
          type="danger"
          plain
          icon="el-icon-close"
          v-permission="Auth.serviceQuestClose"
          v-if="canClose"
          @click="startCloseServiceQuestCloseFormer"
          >关闭
        </el-button>
        <!-- <el-button
          v-if="serviceQuest.status != 1"
          class="mt-10 ml-0"
          size="mini"
          type="primary"
          plain
          icon="el-icon-message"
          v-permission="Auth.serverQuestComent"
          @click="contactsVisible = true"
          >发送短信
        </el-button> -->
      </div>
      <div
        v-if="serviceQuest.status == 3 || serviceQuest.status == 100"
        class="btn-option"
      >
        <el-button
          class="mt-10"
          size="mini"
          type="primary"
          plain
          icon="el-icon-refresh-left"
          v-permission="Auth.serviceQuestUpdate"
          @click="startRollbackFormer"
          >回滚
        </el-button>
      </div>
    </div>
    <div class="panel mt-20">
      <div
        class="header mobile-header"
        style="display: flex; position: relative"
      >
        <h2 style="min-width: 120px">处理流程</h2>
        <div class="flow-container" id="flow-container">
          <div class="flows" style="flex: 1">
            <el-steps
              ref="flowStep"
              :active="flowIndex"
              finish-status="success"
              :space="200"
            >
              <el-step v-for="(step, index) in serviceQuest.steps" :key="index">
                <div slot="title" class="step-title">
                  <span>{{
                    `${step.name}${
                      !isadealer && step.process_category == 10
                        ? '（外部）'
                        : ''
                    }`
                  }}</span>
                  <span
                    :class="{ 'text-danger': serviceQuest.is_over_time }"
                    v-if="
                      index == flowIndex && [1, 2].includes(serviceQuest.status)
                    "
                    >（等待{{ serviceQuest.waited_day }}个工作日{{
                      serviceQuest.is_over_time ? ' 已超时' : ''
                    }}）</span
                  >
                </div>
              </el-step>
            </el-steps>
          </div>
          <div class="times">
            <div v-for="(step, index) in serviceQuest.steps" :key="index">
              <div v-if="index == flowIndex && serviceQuest.status != 3">
                负责人：{{ serviceQuest.current_step_user_name }}
              </div>
              <div v-if="index == flowIndex">
                <el-button
                  v-if="canComplete"
                  ref="stepButton"
                  size="mini"
                  type="primary"
                  @click="serviceQuestDone"
                  >完成
                </el-button>
                <el-button
                  v-if="
                    [0, 1, 2, 3].includes(currentStep.process_category) &&
                    currentStep.father_id >= -1 &&
                    canChangeDierector
                  "
                  size="mini"
                  type="info"
                  @click="startSetApproval(1)"
                  >转移
                </el-button>
              </div>
              <span v-else>
                <span v-if="index < flowIndex">
                  {{ formatTime(step.finished_at, 'YYYY-MM-DD HH:mm') }}</span
                >
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="canSetApproval && !isadealer" class="header mt-20 flex-row">
        <h2 style="width: 120px">添加审批</h2>
        <el-button type="primary" size="mini" plain @click="startSetApproval(0)"
          >选择审批人</el-button
        >
      </div>
      <!-- <div v-if="canDeliveryConfirm" class="header mt-20 flex-row">
        <h2 style="width: 100px">物流操作</h2>
        <el-popconfirm
          :title="
            serviceQuest.mode_status == 9 || serviceQuest.mode_status == 120
              ? '确认已收货吗'
              : '确认已发货吗'
          "
          @confirm="deliveryConfirm"
        >
          <el-button slot="reference" type="primary" size="mini" plain>{{
            serviceQuest.mode_status == 9 || serviceQuest.mode_status == 120
              ? '确认收货'
              : '确认发货'
          }}</el-button>
        </el-popconfirm> 
      </div> -->
    </div>
    <div class="panel mt-20" v-if="canApprove">
      <div class="header mobile-header flex-row">
        <h2 style="width: 120px">审批</h2>
        <div>
          <el-radio size="mini" v-model="approvePass" :label="true"
            >通过</el-radio
          >
          <el-radio size="mini" v-model="approvePass" :label="false"
            >不通过</el-radio
          >
        </div>
      </div>
      <el-button
        style="margin-left: 120px"
        type="danger"
        size="mini"
        @click="submitApprove"
        :disabled="loading"
        >提 交</el-button
      >
    </div>
    <div
      class="panel mt-20"
      v-if="!isadealer || serviceQuest.repair_dealer_id == userInfo.dealer_id"
    >
      <div class="header">
        <h2>{{ serviceQuest.status == 1 ? '方案评估' : '处置回复' }}</h2>
        <!-- <p class="text-info-12">
          {{ ServiceQuestResponseTip[serviceQuest.mode_status] }}
        </p> -->
      </div>
      <el-form
        id="sr-form"
        size="mini"
        label-position="left"
        label-width="120px"
        ref="evaluateForm"
        :model="evaluateForm"
        :rules="evaluateRules"
      >
        <template v-if="canEvaluate && serviceQuest.category == 1">
          <el-form-item label="处置流程" prop="service_quest_flow_id">
            <ServiceQuestFlowSelect
              v-model="evaluateForm.service_quest_flow_id"
              @info="serviceQuest.flow = $event"
            ></ServiceQuestFlowSelect>
            <!-- <div v-if="evaluateForm.mode > 0" class="preview-steps">
              <span>流程预览：</span>
              <template
                v-for="(status, index) in stepsOfFlow(evaluateForm.mode)"
              >
                <span class="arrow" v-if="index != 0">→</span
                ><span> {{ ServiceQuestModeStatus[status] }}</span>
              </template>
            </div> -->
          </el-form-item>
          <div class="evalaute-wrapper">
            <el-form-item
              label="接收地点"
              prop="repair_dealer_id"
              v-if="
                serviceQuest.flow.relative_fileds &&
                serviceQuest.flow.relative_fileds.includes(1)
              "
            >
              <dealer-select
                size="small"
                @change="evaluateForm.repair_dealer_id = $event"
                :isFixDealer="true"
              ></dealer-select>
            </el-form-item>
            <el-form-item
              :label="
                serviceQuest.flow.relative_fileds &&
                serviceQuest.flow.relative_fileds.includes(3)
                  ? '业务机会编号'
                  : 'NCR编号'
              "
              prop="number"
            >
              <el-input size="small" v-model="evaluateForm.number"></el-input>
            </el-form-item>
            <el-form-item
              label="是否上门提货"
              prop="pick_up"
              v-if="
                serviceQuest.flow.relative_fileds &&
                serviceQuest.flow.relative_fileds.includes(4)
              "
            >
              <el-select
                size="small"
                v-model="evaluateForm.pick_up"
                placeholder="请选择"
              >
                <el-option :key="0" label="请选择" :value="0"></el-option>
                <el-option :key="1" label="是" :value="1"></el-option>
                <el-option :key="2" label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>

            <template
              v-if="
                serviceQuest.flow.relative_fileds &&
                serviceQuest.flow.relative_fileds.includes(2)
              "
            >
              <el-form-item key="ServiceOrder" label="Service Order">
                <el-input
                  size="small"
                  placeholder="请填写 Service Order no."
                  v-model="evaluateForm.service_order_no"
                ></el-input>
              </el-form-item>
              <el-form-item label="Notification">
                <el-input
                  size="small"
                  placeholder="请填写 Notification no."
                  v-model="evaluateForm.notification_no"
                ></el-input>
              </el-form-item>
            </template>
            <el-form-item label="OEM厂商">
              <dealer-select
                size="small"
                :category="3"
                :val="evaluateForm.oem_id"
                @change="evaluateForm.oem_id = $event"
                :add="true"
              ></dealer-select
            ></el-form-item>
            <el-form-item label="OEM代码">
              <el-input
                size="small"
                disabled
                readonly
                v-model="evaluateForm.oem_sap_code"
              ></el-input>
            </el-form-item>
            <el-form-item label="OEM联系人">
              <DealerContactSelect
                :add="true"
                :dealerID="evaluateForm.oem_id"
                tip="请先选择OEM厂商"
                v-model="evaluateForm.dealer_contact_id"
              />
            </el-form-item>
            <!-- <el-form-item label="OEM联系人">
              <el-input
                size="small"
                v-model="evaluateForm.oem_contact_name"
              ></el-input>
            </el-form-item>
            <el-form-item label="OEM联系电话">
              <el-input
                size="small"
                v-model="evaluateForm.oem_contact_phone"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="设备号">
              <el-input
                size="small"
                v-model="evaluateForm.product_number"
              ></el-input>
            </el-form-item>
            <el-form-item label="产品发货日期">
              <el-date-picker
                v-model="evaluateForm.delivery_date"
                type="date"
                size="small"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="保修类型">
              <el-select
                v-model="evaluateForm.warranty_type"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in WarrantyTypes"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="FSE现场检测">
              <el-select
                v-model="evaluateForm.fse_testing"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in PSETestings"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="新品销售">
              <NewProductSaleSelect
                v-model="evaluateForm.new_product_sale_id"
                :add="true"
              ></NewProductSaleSelect>
            </el-form-item>

            <el-form-item label="生产工厂" prop="factory">
              <el-select
                v-model="evaluateForm.factory"
                placeholder="请选择"
                size="small"
              >
                <el-option key="TJ" label="TJ" value="TJ"> </el-option>
                <el-option key="KN" label="KN" value="KN"> </el-option>
                <el-option key="QD" label="QD" value="QD"> </el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>

        <!-- <el-form-item
          v-if="
            (evaluateForm.in_repair_scope || serviceQuest.category == 2) &&
            serviceQuest.mode == 0
          "
          label="维修工程师"
          prop="user_id"
        >
          <user-select
            :val="evaluateForm.engineer_id"
            :role="''"
            @change="evaluateForm.engineer_id = $event"
          ></user-select>
        </el-form-item> -->
        <!-- <template v-if="serviceQuest.mode_status == 301">
          <el-form-item label="是否自费修理">
            <el-radio v-model="ownExpense" :label="true">是</el-radio>
            <el-radio v-model="ownExpense" :label="false">否</el-radio>
          </el-form-item>
        </template> -->
        <template v-if="canEvaluate && serviceQuest.category == 2">
          <el-form-item label="NCR编号" prop="number">
            <el-input size="small" v-model="evaluateForm.number"></el-input>
          </el-form-item>
          <el-form-item label="收购价格(元)">
            <el-input
              placeholder="请输入预估收购价格"
              v-model="evaluateForm.quoted_price"
              size="small"
              style="width: 220px"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="维修成本(元)">
            <el-input
              placeholder="请输入预估维修成本"
              size="small"
              v-model="evaluateForm.maintenance_cost"
              style="width: 220px"
            >
            </el-input>
          </el-form-item>
        </template>

        <template
          v-if="
            serviceQuest.category == 1 &&
            currentStep.relative_fileds &&
            currentStep.relative_fileds.includes(1)
          "
        >
          <el-form-item
            label="Service Order no."
            v-if="!haveFormDataParam('service_order_no')"
          >
            <el-input
              size="small"
              v-model="form_data.service_order_no"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Notification no."
            v-if="!haveFormDataParam('service_order_no')"
          >
            <el-input
              size="small"
              v-model="form_data.notification_no"
            ></el-input>
          </el-form-item>
        </template>

        <!-- <template
          v-if="
            serviceQuest.category == 1 &&
            !isadealer &&
            (serviceQuest.mode_status == 5 ||
              serviceQuest.mode_status == 10 ||
              serviceQuest.mode_status == 113)
          "
        >
          <el-form-item
            label="质保判定"
            v-if="!haveFormDataParam('oversea_check')"
          >
            <el-checkbox v-model="form_data.oversea_check" key="oversea_check"
              >海外判定</el-checkbox
            >
          </el-form-item>
          <el-form-item
            label="海外判定"
            v-if="
              haveFormDataParam('oversea_check') &&
              !haveFormDataParam('oversea_sended')
            "
            key="oversea_sended"
          >
            <el-checkbox v-model="form_data.oversea_sended"
              >完成发货</el-checkbox
            >
          </el-form-item>
        </template>

        <el-form-item
          label="销售过程"
          v-if="
            serviceQuest.category == 1 &&
            serviceQuest.mode_status == 6 &&
            notInWarranty &&
            !haveFormDataParam('sale_process')
          "
        >
          <el-input size="small" v-model="form_data.sale_process"></el-input>
        </el-form-item> -->

        <el-form-item label="内容">
          <div
            class="text-danger"
            v-if="serviceQuest.status == 2 && serviceQuest.mode_status == 111"
          >
            *请在此处提供维修方案和备件清单
          </div>

          <div
            :class="{
              commentcontainer:
                serviceQuest.status == 2 && serviceQuest.mode_status == 111,
            }"
          >
            <rich-editor class="editor" v-model="content"> </rich-editor>
            <div
              class="prod-container"
              v-if="serviceQuest.status == 2 && serviceQuest.mode_status == 111"
            >
              <div class="mb-5 font-14 name" v-if="selectedProducts.length > 0">
                备件清单
              </div>
              <el-table
                :data="selectedProducts"
                border
                size="small"
                style="width: 100%; max-width: 1000px"
                v-if="selectedProducts.length > 0"
              >
                <el-table-column prop="name" label="件号" min-width="120">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.part_number }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="描述" min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.description }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="count"
                  label="数量"
                  align="center"
                  width="160"
                >
                  <template slot-scope="scope">
                    <el-input-number
                      size="mini"
                      v-model="scope.row.count"
                      :min="1"
                      :step="1"
                    >
                    </el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120">
                  <template slot-scope="scope">
                    <el-button
                      class="text-danger"
                      type="text"
                      size="mini"
                      plain
                      @click="removeProducts(scope.$index)"
                      >移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                size="small"
                type="text"
                icon="el-icon-plus"
                @click="productSelectorVisible = true"
                >添加备件</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="附件">
          <el-upload
            :action="uploadUrl"
            :limit="5"
            ref="uploader"
            accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx, .mp4"
            multiple
            :headers="uploadHeader"
            :on-error="handleUploadError"
            :before-upload="beforeUpload"
            :on-change="handlerFileListChange"
            :on-exceed="handleExceed"
          >
            <el-button size="small" type="text" icon="el-icon-paperclip"
              >添加附件</el-button
            >
            <!-- <label class="text-info-12 ml-10">如HS2等。</label> -->
          </el-upload>
        </el-form-item>
        <el-form-item label="">
          <el-button
            size="small"
            type="primary"
            @click="submitResponse()"
            :disabled="loading"
            >提 交
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="panel mt-10"
      v-if="serviceQuest.responses && serviceQuest.responses.length > 0"
    >
      <div
        class="timeline-cell"
        v-for="(res, index) in serviceQuest.responses"
        :key="res.id"
      >
        <div
          class="line-y"
          v-if="index < serviceQuest.responses.length - 1"
        ></div>
        <div :class="res.category >= 200 ? 'node info' : 'node'">
          {{ res.step_name }}
        </div>
        <div class="content">
          <div class="card">
            <div class="flex-row name-info">
              <span class="font-12 text-primary">{{ res.user.name }}</span>
              <span class="text-info-12 ml-10">{{
                formatTime(res.created_at, 'YYYY-MM-DD HH:mm')
              }}</span>
            </div>
            <div class="desc">
              <div v-if="res.status == 1">
                {{ res.category != 200 ? '完成' : '' }}
                {{ res.step_name }}
              </div>
              <div v-if="res.category == 111">
                <div v-html="res.desc"></div>
                <div
                  class="mb-5"
                  v-if="res.form_data && res.form_data.products"
                >
                  备件清单
                </div>
                <el-table
                  :data="res.form_data.products"
                  v-if="res.form_data && res.form_data.products"
                  border
                  size="small"
                  style="width: 100%; max-width: 1000px"
                >
                  <el-table-column prop="name" label="件号" min-width="120">
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.part_number }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="描述" min-width="220">
                    <template slot-scope="scope">
                      <span>{{ scope.row.description }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="count" label="数量" align="center">
                  </el-table-column>
                </el-table>
              </div>
              <div v-else>
                <div v-for="(item, index) in res.form_data" :key="index">
                  {{ item.name }}：{{ item.value }}
                </div>
                <div v-html="res.desc"></div>
              </div>
            </div>
            <div class="attachements" v-if="res.files && res.files.length > 0">
              <div class="text-info-12">
                <i class="el-icon-paperclip"></i>
                附件
              </div>
              <div
                class="file-item text-primary"
                v-for="file in res.files"
                v-if="file.url && !file.url.token"
              >
                <i
                  :class="
                    isImage(file.url)
                      ? 'el-icon-picture-outline'
                      : 'el-icon-files'
                  "
                ></i>
                <a :href="file.url + '?t=' + FileToken" :download="file.name">{{
                  file.name
                }}</a>
                <span
                  class="pointer preview"
                  v-if="canPreviewFile(file.url)"
                  @click="filePreview(file.url + '?t=' + FileToken)"
                  >预览</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <service-quest-former
      :model="serviceQuestForm"
      :show.sync="updateServiceQuestFormVisible"
      @updated="updatedServiceQuest"
    ></service-quest-former>
    <service-quest-close-former
      :model="serviceQuestCloseForm"
      :serviceQuest="serviceQuest"
      :show.sync="serviceQuestCloseFormVisibile"
      @updated="updatedServiceQuest"
    ></service-quest-close-former>
    <warranty-decision-former
      :show.sync="warrantyDecisionVisible"
      :model="warrantyDecisionModel"
      @refresh="requestServiceQuest"
    ></warranty-decision-former>
    <rollback-former
      :show.sync="rollbackFormerVisible"
      :model="rollbackModel"
      :serviceQuest="serviceQuest"
      @refresh="requestServiceQuest"
    ></rollback-former>
    <item-selector
      :show.sync="productSelectorVisible"
      :multiple="true"
      :selection="selectedProducts"
      @selected="doneSelectedProducts"
    ></item-selector>
    <approval-selector
      :show.sync="setApprovalVisible"
      :model="setApprovalModel"
      @refresh="requestServiceQuest"
    ></approval-selector>
    <VideoDialog :show.sync="videoVisible" :src="videoSrc"></VideoDialog>
    <DeviceAddressFormer
      :model="deviceAddress"
      :show.sync="deviceAddressFormVisible"
      @updated="deviceAddressUpdated"
    >
    </DeviceAddressFormer>
    <hs-former :show.sync="showHS2" :model="serviceQuest.hs2"></hs-former>
    <SapCodeFormer
      :show.sync="sapCodeVisible"
      :model="sapCodeCustomer"
      @updatedCustomer="requestServiceQuest"
    >
    </SapCodeFormer>

    <StepDoneFormer
      :model="doneModel"
      :show.sync="doneModelVisible"
      @updated="requestServiceQuest"
    ></StepDoneFormer>
    <CustomerContacts
      :show.sync="contactsVisible"
      :customerID="serviceQuest.customer_id"
      :serviceQuestID="serviceQuest.id"
    ></CustomerContacts>
  </div>
</template>
<script>
import {
  serviceQuestDetail,
  serviceQuestClose,
  serviceQuestDeliveryConfirm,
  dealerDetail,
  updateServiceQuest,
  getMPUrl,
  updateServiceQuestNumber,
} from '../../service/getData'

import {
  serviceQuestEvaluate,
  serviceQuestDone,
  createServiceQuestResponse,
  serviceQuestApprove,
} from '@/service/getDataV2'

import {
  formatTime,
  clone,
  canPreviewFile,
  isImage,
  timeWait,
} from '@/util/index'
import ServiceQuestFormer from '../../components/service_quest'
import UserSelect from '@/components/select/user_select'
import ItemSelector from '@/components/commodity_selector'
import ServiceQuestFlowSelect from '@/components/select/service_quest_flow_select'
import ServiceQuestCloseFormer from '@/components/service_quest_close'
import DealerSelect from '@/components/select/dealer_select'
import NewProductSaleSelect from '@/components/select/new_product_sale_select'
import RollbackFormer from '@/components/service_quest_rollback'
import ApprovalSelector from './approval_selector_v2'
import VideoDialog from './videoDialog'
import HsFormer from './hs2_preview'
import CustomerContacts from './customer_contacts'
import StepDoneFormer from './step_done_former.vue'
import SapCodeFormer from './sap_code_former'
import VueClipboards from 'vue-clipboards'
import Vue from 'vue'
Vue.use(VueClipboards)

import {
  urlPerfix,
  host,
  thumbnailImagePath,
  originImagePath,
} from '@/config/env'
import { hasAuth } from '@/permission'

import {
  ServiceQuestLevelMap,
  ServiceQuestSourceMap,
  ServiceQuestStatusMap,
  ServiceQuestModeStatus,
  ServiceQuestResponseTip,
  ServiceQuestFlow,
  ServiceQuestMode,
} from '@/config/global.js'
import store from '@/store/store'
import RichEditor from '@/components/rich-editor'
import math from '../../util/math'
import {
  ServiceQuestModeAuth,
  WarrantyTypes,
  PSETestings,
} from '../../config/global'
import WarrantyDecisionFormer from '@/components/warranty_decision_former'
import DealerContactSelect from '@/components/select/dealer_contact_select'
import { isMobile } from '@/util'
import { CodeToText } from '@/util/area_tool'
import DeviceAddressFormer from '@/components/customer_device_address'

const formDataTextMap = {
  service_order_no: 'Service Order no.',
  notification_no: 'Notification no.',
  oversea_check: '海外判定',
  oversea_sended: '海外判定',
  sale_process: '销售过程',
}
export default {
  components: {
    ItemSelector,
    NewProductSaleSelect,
    ServiceQuestFormer,
    UserSelect,
    ServiceQuestCloseFormer,
    RichEditor,
    DealerSelect,
    WarrantyDecisionFormer,
    RollbackFormer,
    ApprovalSelector,
    VideoDialog,
    HsFormer,
    DealerContactSelect,
    DeviceAddressFormer,
    SapCodeFormer,
    ServiceQuestFlowSelect,
    StepDoneFormer,
    CustomerContacts,
  },
  data() {
    var checkPickUp = (rule, value, callback) => {
      if (value == 0) {
        return callback(new Error('请选择是否上门提货'))
      }
      callback()
    }
    return {
      mp_hs_link: '',
      mp_logistics_link: '',
      timeWait,
      contactsVisible: false,
      sapCodeCustomer: { id: 0, sap_code: '', certify: true, name: '' },
      sapCodeVisible: false,
      saleCheckModeStatus: [14, 114, 101, 111], //几个流程的销售处理步骤可以转移负责人
      fromOngoingList: this.$route.name == 'service_quests_ongoing',
      preAndNextOrderInfo: { pre_order_info: '', next_order_info: '' },
      deviceAddressFormVisible: false,
      deviceAddress: {},
      CodeToText,
      videoSrc: '',
      videoVisible: false,
      productSelectorVisible: false,
      selectedProducts: [],
      isadealer: store.getters.userInfo.dealer_id > 0,
      hs2Url: '',
      logisticsUrl: '',
      hs2CopyTip: '复制',
      logisticsCopyTip: '复制',
      sqCopyTip: '复制',
      showHS2: false,
      formatTime,
      ServiceQuestStatusMap,
      ServiceQuestLevelMap,
      WarrantyTypes,
      PSETestings,
      updateServiceQuestFormVisible: false,
      serviceQuestForm: null,
      serviceQuestCloseForm: {},
      serviceQuestCloseFormVisibile: false,
      id: this.$route.params.id,
      serviceQuest: {},
      content: '',
      ServiceQuestModeStatus,
      ServiceQuestResponseTip,
      ServiceQuestMode,
      ServiceQuestFlow,
      isImage: isImage,
      canPreviewFile: canPreviewFile,
      unfold: false,
      loading: false,
      host: host,
      uploadUrl: urlPerfix + '/files/upload',
      userInfo: store.state.userInfo,
      uploadHeader: { Token: store.state.userInfo.token },
      routers: {},
      times: [],
      warrantyDecisionVisible: false,
      warrantyDecisionModel: {},
      rollbackFormerVisible: false,
      rollbackModel: {},
      setApprovalVisible: false,
      setApprovalModel: {},
      approvePass: true,
      editorOption: {
        placeholder: '请输入反馈内容',
        modules: {
          toolbar: [
            'bold',
            'italic',
            'underline',
            'strike',
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
            { size: ['small', false, 'large', 'huge'] },
            'link',
          ],
        },
      },
      evaluateForm: {
        number: '',
        mode: null,
        service_quest_flow_id: null,
        desc: '',
        pick_up: 0,
        oem_id: null,
        oem_sap_code: '',
        dealer_contact_id: '',
        repair_dealer_id: '',
        product_number: '',
        delivery_date: '',
        warranty_type: '',
        fse_testing: '',
        factory: '',
        new_product_sale_id: '',
        service_order_no: '',
        notification_no: '',
      },
      serviceQuestResponse: {
        desc: '',
        files: [],
      },
      form_data: {},
      ownExpense: true,
      fileList: [],
      stepButtonLeft: 0,
      evaluateRules: {
        service_quest_flow_id: [
          { required: true, message: '请选择处置流程', trigger: 'change' },
        ],
        repair_dealer_id: [
          { required: true, message: '请选择维修地点', trigger: 'change' },
        ],
        pick_up: [
          { validator: checkPickUp, trigger: 'change' },
          { required: true, message: '请选择是否上门提货', trigger: 'change' },
        ],
        service_order_no: [
          {
            required: true,
            message: '请填写 Service Order no.',
            trigger: 'change',
          },
        ],
        number: [{ required: true, message: '请填写此项', trigger: 'blur' }],
        factory: [
          { required: true, message: '请选择生产工厂', trigger: 'change' },
        ],
      },
      doneModel: {
        id: 0,
        step: {},
        next_step_id: null,
        has_not_done: null,
        msg_send_type: 0,
        dealer_customer_id: 0,
        customer_contact_id: null,
        customer_id: null,
        customer_name: '',
        is_last_step: false,
        remark: '',
      },
      doneModelVisible: false,
    }
  },
  watch: {
    'evaluateForm.oem_id': function () {
      if (this.evaluateForm.oem_id > 0) {
        this.requestOEMDetail(this.evaluateForm.oem_id)
      }
    },
  },
  computed: {
    shareUrl() {
      return `https://${window.location.host}/sqs/${this.serviceQuest.uuid}`
    },
    canEvaluate() {
      return (
        this.flowIndex == 1 &&
        (this.serviceQuest.status == 1 || this.serviceQuest.status == 2)
      )
    },
    levelTagClass() {
      switch (this.serviceQuest.level) {
        case 1:
          return 'text-info'
          break
        case 2:
          return 'text-danger'
        case 3:
          return 'text-danger'
        default:
          return 'text-info'
          break
      }
    },
    canClose() {
      return this.serviceQuest.status != 100 && this.serviceQuest.status != 3
    },
    canSetApproval() {
      return (
        this.serviceQuest.status == 2 &&
        this.currentStep.father_id >= 0 &&
        this.serviceQuest.approval_id == 0
      )
    },
    canDeliveryConfirm() {
      let mode_statuss = [9, 11, 120, 121]
      return (
        this.serviceQuest.status == 2 &&
        mode_statuss.indexOf(this.serviceQuest.mode_status) != -1 &&
        this.serviceQuest.repair_dealer_id == this.userInfo.dealer_id &&
        this.serviceQuest.delivery_confirm == 1
      )
    },
    canApprove() {
      return (
        this.serviceQuest.approval_id == this.userInfo.id &&
        this.serviceQuest.approve_index == 0
      )
    },
    currentStep() {
      return this.serviceQuest.steps[this.flowIndex] || {}
    },
    canComplete() {
      if (
        this.serviceQuest.current_step_id &&
        (this.serviceQuest.approval_id == 0 ||
          this.serviceQuest.approve_index > 0) &&
        (this.serviceQuest.status == 1 || this.serviceQuest.status == 2)
      ) {
        if (this.currentStep.father_id == -1) {
          const mode = this.serviceQuest.mode_status
          const auth = ServiceQuestModeAuth[mode]
          if (hasAuth(auth)) {
            return true
          }
        }

        if ([1, this.serviceQuest.director_id].includes(this.userInfo.id)) {
          return true
        } else if (this.currentStep.process_category == 10) {
          //中间商处理
          return this.userInfo.dealer_id == this.serviceQuest.repair_dealer_id
        } else if (this.currentStep.process_category == 2) {
          //销售处理
          return [
            this.serviceQuest.customer.platform_user_id,
            this.serviceQuest.customer.telesale_id,
          ].includes(this.userInfo.id)
        } else {
          //指定负责人
          return (
            this.currentStep.director_ids &&
            this.currentStep.director_ids.includes(this.userInfo.id)
          )
        }
      }
      return false
    },

    canChangeDierector() {
      if (
        this.serviceQuest.current_step_id &&
        (this.serviceQuest.approval_id == 0 ||
          this.serviceQuest.approve_index > 0) &&
        (this.serviceQuest.status == 1 || this.serviceQuest.status == 2)
      ) {
        //有评估权限
        if (hasAuth('serviceQuestEvaluate')) {
          return true
        }

        if ([1, this.serviceQuest.director_id].includes(this.userInfo.id)) {
          return true
        }

        if (
          this.currentStep.director_ids &&
          this.currentStep.director_ids.includes(this.userInfo.id)
        ) {
          return true
        }

        if (this.currentStep.process_category == 2) {
          //销售处理
          return [
            this.serviceQuest.customer.platform_user_id,
            this.serviceQuest.customer.telesale_id,
            this.serviceQuest.customer.new_product_sale_id,
          ].includes(this.userInfo.id)
        }
      }
      return false
    },

    canResponse() {
      if (this.serviceQuest.status == 100 || this.serviceQuest.status == 3) {
        return false
      }

      const mode = this.serviceQuest.mode_status
      if (mode == 1 && hasAuth('serviceQuestEvaluate')) {
        return true
      } else if (
        [101, 202, 203, 204, 302].indexOf(mode) != -1 &&
        hasAuth('serviceQuestFlowEngineer')
      ) {
        return true
      } else if (
        [201, 301, 205].indexOf(mode) != -1 &&
        hasAuth('serviceQuestFlowSale')
      ) {
        return true
      } else if (
        [401].indexOf(mode) != -1 &&
        hasAuth('serviceQuestFlowAdmin')
      ) {
        return true
      }

      return false
    },
    showFlowButton() {
      return (
        this.canResponse &&
        this.serviceQuest.mode_status > 1 &&
        this.serviceQuest.mode_status != 100
      )
    },
    flowIndex() {
      if (!this.serviceQuest.steps) {
        return 0
      }

      // if (this.serviceQuest.status == 3) {
      //   return 100
      // }

      if (this.serviceQuest.status == 100) {
        return 100
      }

      let index = 1
      let steps = this.serviceQuest.steps.filter(
        (step) => step.id == this.serviceQuest.current_step_id,
      )
      if (steps.length > 0) {
        index = this.serviceQuest.steps.indexOf(steps[0])
      }
      return index
    },
    haveFormDataParam() {
      return function (param) {
        const preStepResponses = this.serviceQuest.responses.filter(
          (item) => item.category == this.serviceQuest.mode_status - 1,
        )

        if (preStepResponses.length == 0) {
          return false
        }

        let id = preStepResponses[preStepResponses.length - 1].id || 0
        const responses = this.serviceQuest.responses.filter(
          (item) => item.id > id,
        )
        if (responses) {
          for (let i = 0; i < responses.length; i++) {
            const response = responses[i]
            if (response.form_data && response.form_data[param]) {
              return true
            }
          }
          return false
        }
        return false
      }
    },

    getFormDataParam() {
      return function (param) {
        let value = ''
        const responses = this.serviceQuest.responses

        // if (responses.length == 0) {
        //   return ''
        // }

        // console.log(responses)

        // let id = responses[responses.length - 1].id || 0
        // const responses = this.serviceQuest.responses.filter(
        //   (item) => item.id > id
        // )
        if (responses) {
          for (let i = 0; i < responses.length; i++) {
            const response = responses[i]
            if (response.form_data && response.form_data[param]) {
              value = response.form_data
              // return response.form_data[param].value
            }
          }
          // return ''
        }
        return value
      }
    },
    notInWarranty() {
      const responses = this.serviceQuest.responses.filter(
        (item) => item.category == 5,
      )

      if (responses.length > 0) {
        return responses[responses.length - 1].desc.indexOf('不在质保期') != -1
      }
      return false
    },

    overseaCheck() {
      if (this.serviceQuest.responses) {
        const responses = this.serviceQuest.responses.filter(
          (item) => item.category == 5,
        )
        for (let i = 0; i < responses.length; i++) {
          const response = responses[i]
          if (response.form_data && response.form_data.oversea_check) {
            return true
          }
        }
        return false
      }
      return false
    },
    finishiDelivery() {
      if (this.serviceQuest.responses) {
        const responses = this.serviceQuest.responses.filter(
          (item) => item.category == 5,
        )
        for (let i = 0; i < responses.length; i++) {
          const response = responses[i]
          if (response.form_data && response.form_data.oversea_sended) {
            return true
          }
        }
        return false
      }
      return false
    },
  },
  created() {
    this.requestServiceQuest(true)
  },
  methods: {
    async requestServiceQuest(set_pn_order_info = false) {
      let res = await serviceQuestDetail(this.id)
      this.serviceQuest = res.data

      if (set_pn_order_info) {
        this.preAndNextOrderInfo.pre_order_info =
          this.serviceQuest.pre_order_info
        this.preAndNextOrderInfo.next_order_info =
          this.serviceQuest.next_order_info
      }
      if (this.serviceQuest.mode_status == 1) {
        for (const key in this.evaluateForm) {
          if (this.serviceQuest[key]) {
            this.evaluateForm[key] = this.serviceQuest[key]
          }

          if (
            key == 'service_order_no' &&
            (this.serviceQuest.mode == 1 ||
              this.serviceQuest.mode == 7 ||
              this.serviceQuest.mode == 11) &&
            this.getFormDataParam('service_order_no')
          ) {
            this.evaluateForm[key] =
              this.getFormDataParam('service_order_no').service_order_no.value
          }
          if (
            key == 'notification_no' &&
            (this.serviceQuest.mode == 1 ||
              this.serviceQuest.mode == 7 ||
              this.serviceQuest.mode == 11) &&
            this.getFormDataParam('notification_no')
          ) {
            this.evaluateForm[key] =
              this.getFormDataParam('service_order_no').notification_no.value
          }
        }

        if (this.serviceQuest.customer_device_id) {
          this.evaluateForm.product_number =
            this.serviceQuest.device.equipment_number
          if (this.serviceQuest.device.purchase_time) {
            this.evaluateForm.delivery_date =
              this.serviceQuest.device.purchase_time.includes('0001-01-01')
                ? ''
                : formatTime(this.serviceQuest.device.purchase_time)
          }
        }
      }

      this.computeTimes()

      if (isMobile()) {
        this.$nextTick(() => {
          document.querySelector('#flow-container').scrollLeft =
            this.flowIndex > 0 ? (this.flowIndex - 1) * 150 : 0
        })
      }
    },

    gotoDetail(id) {
      if (id) {
        this.$router.replace(`/dashboard/service_quests/my/${id}?origin=0`)
      }
    },

    editNumber() {
      this.$prompt('NCR编号', '编辑', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(?!\s*$).+/,
        inputErrorMessage: 'NCR编号不能为空',
      })
        .then(async ({ value }) => {
          if (value) {
            let res = await updateServiceQuestNumber({
              id: this.serviceQuest.id,
              number: value,
            })
            if (res.code == 0) {
              this.serviceQuest.number = value
            }
          }
        })
        .catch(() => {})
    },

    showDeviceAddressFormer() {
      this.deviceAddressFormVisible = true
      let address = this.serviceQuest.device.address
      let area = []
      if (address.province) {
        area.push(address.province)
      }
      if (address.city) {
        area.push(address.city)
      }
      if (address.county) {
        area.push(address.county)
      }

      this.deviceAddress = {
        id: address.id,
        detail: address.detail,
        area: area,
      }
    },

    deviceAddressUpdated(res) {
      if (res) {
        this.serviceQuest.device.address.province = res.province
        this.serviceQuest.device.address.city = res.city
        this.serviceQuest.device.address.county = res.county
        this.serviceQuest.device.address.detail = res.detail
      }
    },

    doneSelectedProducts(products) {
      let pitems = products.map((p) => {
        let qitem = {
          id: p.id,
          count: 1,
          part_number: p.part_number,
          description: p.description,
        }
        return qitem
      })
      let oproducts = this.selectedProducts
      this.selectedProducts = oproducts.concat(pitems)
    },

    removeProducts(index) {
      this.selectedProducts.splice(index, 1)
    },

    videoPlay(src) {
      this.videoSrc = src
      this.videoVisible = true
    },

    async getHS2MPUrl() {
      // if (this.serviceQuest.mp_hs_url) {
      //   return
      // }
      let res = await getMPUrl({
        order_id: this.id,
        category: 'hs',
        token_validate: false,
      })
      if (res.code == 0) {
        this.mp_hs_link = res.data
      }
    },
    async getLogisticsMPUrl() {
      // if (this.serviceQuest.mp_logistics_url) {
      //   return
      // }
      let res = await getMPUrl({
        order_id: this.id,
        category: 'logistics',
        token_validate: false,
      })
      if (res.code == 0) {
        this.mp_logistics_link = res.data
      }
    },
    copySuccess(param) {
      this[param] = '复制成功'
      let that = this
      setTimeout(function () {
        that[param] = '复制'
      }, 1000)
    },
    // refreshQuest() {
    //   this.$confirm('确定恢复流程吗', '操作提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //   })
    //     .then(async () => {
    //       let data = clone(this.serviceQuest)
    //       data.status = 2
    //       let res = await updateServiceQuest(data)

    //       if (res.code == 0) {
    //         this.requestServiceQuest
    //         this.serviceQuest.status = 2
    //         this.$message.success('恢复成功！')
    //       }
    //     })
    //     .catch((action) => {})
    // },
    computeTimes() {},
    startServiceQuestFormer() {
      this.serviceQuestForm = clone(this.serviceQuest)
      this.serviceQuestForm.customer_device_address_id =
        this.serviceQuestForm.device.address.id
      this.serviceQuestForm.device_running_time =
        this.serviceQuestForm.device.running_time || 0
      this.serviceQuestForm.device_application =
        this.serviceQuestForm.device.product_application || []
      this.updateServiceQuestFormVisible = true
    },
    startCloseServiceQuestCloseFormer() {
      this.serviceQuestCloseForm = {
        service_quest_id: this.serviceQuest.id,
        desc: '',
      }
      this.serviceQuestCloseFormVisibile = true
    },
    updatedServiceQuest(sq) {
      this.serviceQuest = sq
      this.computeTimes()
    },
    async deliveryConfirm() {
      let res = await serviceQuestDeliveryConfirm({ id: this.serviceQuest.id })
      if (res.code == 0) {
        this.requestServiceQuest()
      }
    },
    submitResponse() {
      this.$refs.evaluateForm.validate(async (valid) => {
        if (valid) {
          let fileList = this.fileList.map((i) => {
            return {
              name: i.name,
              url: i.response.data,
              size: i.size,
            }
          })
          this.loading = true
          if (this.flowIndex == 1) {
            let data = clone(this.evaluateForm)
            data.service_quest_id = this.serviceQuest.id
            data.desc = this.content
            data.files = fileList
            if (!data.dealer_contact_id) {
              data.dealer_contact_id = 0
            }

            if (!data.new_product_sale_id) {
              data.new_product_sale_id = 0
            }

            if (!data.repair_dealer_id) {
              data.repair_dealer_id = 0
            }

            if (this.serviceQuest.category == 2) {
              data.mode = 10
              data.quoted_price = parseFloat(data.quoted_price)
              data.maintenance_cost = parseFloat(data.maintenance_cost)
            }

            let res = await serviceQuestEvaluate(data)
            if (res.code == 0) {
              this.$message.success('提交成功！')
              this.serviceQuest = res.data
              this.computeTimes()
              this.resetResponseFormer()
            }
          } else {
            let data = clone(this.serviceQuestResponse)
            data.service_quest_id = this.serviceQuest.id
            data.desc = this.content
            data.files = fileList
            data.form_data = {}

            let _this = this
            Object.keys(this.form_data).forEach(function (key) {
              let val = _this.form_data[key]
              if (val) {
                if (key == 'oversea_check') {
                  val = val === true ? '是' : '否'
                } else if (key == 'oversea_sended') {
                  val = val === true ? '完成发货' : ''
                }
                data.form_data[key] = {
                  name: formDataTextMap[key],
                  value: val,
                }
              }
            })

            if (this.selectedProducts.length > 0) {
              data.form_data.products = this.selectedProducts
            }

            if (this.serviceQuest.mode_status == 301 && !this.ownExpense) {
              let res = await serviceQuestClose(data)
              if (res.code == 0) {
                this.$message.success('提交成功！')
                this.serviceQuest = res.data
                this.computeTimes()
                this.resetResponseFormer()
              }
            } else {
              let res = await createServiceQuestResponse(data)
              if (res.code == 0) {
                this.$message.success('提交成功！')
                this.serviceQuest.responses.push(res.data)
                this.resetResponseFormer()
              }
            }
          }
          this.loading = false
        } else {
          console.log('err')
        }
      })
    },
    serviceQuestDone() {
      this.doneModel.id = this.serviceQuest.id
      this.doneModel.customer_id = this.serviceQuest.customer_id
      this.doneModel.customer_name = this.serviceQuest.customer.name
      this.doneModel.next_step_id = null
      this.doneModel.has_not_done = null
      this.doneModel.customer_contact_id = null
      this.doneModel.is_last_step =
        this.flowIndex > 1 &&
        this.flowIndex == this.serviceQuest.steps.length - 1
      this.doneModel.step = this.serviceQuest.steps[this.flowIndex]
      this.doneModel.msg_send_type = this.serviceQuest.dealer_id ? 1 : 0
      this.doneModel.dealer_customer_id = this.serviceQuest.dealer.twin_id
      this.doneModelVisible = true
      return
      if (
        this.serviceQuest.mode_status == 3 &&
        !this.haveFormDataParam('service_order_no')
      ) {
        this.$alert('请先在下面处置回复里提交 Service Order no.')
        return
      } else if (
        this.serviceQuest.mode_status == 6 &&
        this.notInWarranty &&
        !this.haveFormDataParam('sale_process')
      ) {
        this.$alert('请先在下面处置回复里提交销售过程')
        return
      }

      // if (this.serviceQuest.mode_status == 9) {
      //   this.warrantyDecisionVisible = true
      //   this.warrantyDecisionModel = {
      //     id: this.serviceQuest.id,
      //     mode_status: this.serviceQuest.mode_status,
      //     title: '操作提示',
      //     desc: '请填写Service Order no.',
      //   }
      //   return
      // }

      if (this.serviceQuest.mode_status == 111) {
        this.warrantyDecisionVisible = true
        this.warrantyDecisionModel = {
          id: this.serviceQuest.id,
          mode_status: this.serviceQuest.mode_status,
          title: '方案确认',
          desc: '请选择方案',
          in_repair_scope: 2,
        }
        return
      }

      if (
        this.serviceQuest.mode_status == 5 ||
        this.serviceQuest.mode_status == 10 ||
        this.serviceQuest.mode_status == 113
      ) {
        this.warrantyDecisionVisible = true
        this.warrantyDecisionModel = {
          id: this.serviceQuest.id,
          mode_status: this.serviceQuest.mode_status,
          in_repair_scope: 1,
          give_insurance: 1,
        }
        return
      }

      if (this.serviceQuest.mode_status == 32) {
        this.warrantyDecisionVisible = true
        this.warrantyDecisionModel = {
          id: this.serviceQuest.id,
          title: '返回判定',
          desc: '是否需要返回',
          in_repair_scope: 1,
        }
        return
      }

      let that = this
      this.$confirm(
        '是否确定完成 ' +
          ServiceQuestModeStatus[that.serviceQuest.mode_status] +
          '?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).then(() => {
        serviceQuestDone({ id: that.serviceQuest.id }).then((res) => {
          if (res.code == 0) {
            that.requestServiceQuest()
          }
        })
      })
    },
    handleSuccess(res, file) {
      if (res.code == 0) {
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.file
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.file}MB!`)
      }
      return isLimitSize
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`,
      )
    },
    handlerFileListChange(file, fileList) {
      this.fileList = fileList
    },
    filePreview(file) {
      if (!file) return
      window.open(file, '_blank')
      return
    },
    stepsOfFlow(mode) {
      if (ServiceQuestFlow[mode]) {
        return ServiceQuestFlow[mode].map((item) => {
          return item
        })
      }
      return []
    },
    async submitApprove() {
      this.loading = true
      let res = await serviceQuestApprove({
        id: this.serviceQuest.id,
        pass: this.approvePass,
      })
      if (res.code == 0) {
        this.requestServiceQuest()
      }
      this.loading = false
    },
    async requestOEMDetail(id) {
      let res = await dealerDetail(id)
      if (res.code == 0) {
        // this.evaluateForm.oem_sap_code = res.data.oem_sap_code
        this.evaluateForm.oem_sap_code = res.data.sap_code
        // this.evaluateForm.oem_contact_name = res.data.contact_name
        // this.evaluateForm.oem_contact_phone = res.data.contact_mobile
      }
    },
    startRollbackFormer() {
      this.rollbackModel = {
        id: this.serviceQuest.id,
        mode_status: null,
      }
      this.rollbackFormerVisible = true
    },
    startSetApproval(type = 0) {
      this.setApprovalModel = {
        id: this.serviceQuest.id,
        type: type,
        approval_id: null,
        approve_index: 0,
        lastStep: this.flowIndex == this.serviceQuest.steps.length - 1,
      }
      this.setApprovalVisible = true
    },
    resetResponseFormer() {
      this.content = ''
      this.fileList = []
      this.form_data = {}
      this.selectedProducts = []
      this.$refs.uploader.clearFiles()
    },
  },
}
</script>

<style scoped>
.pn-order {
  display: flex;
  justify-content: space-between;
  position: relative;
  top: 8px;
}

/deep/.pn-order .el-link--inner {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.5);
}

.infos dl {
  display: flex;
  font-size: 12px;
  margin-bottom: 8px;
}

.infos dl dd {
  margin-bottom: 0;
}

.infos dl dt {
  width: 80px;
  min-width: 80px;
  color: #bec4cb;
  font-weight: 400;
}

.level-info {
  display: flex;
  align-items: center;
}

.level-info i {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin-right: 5px;
}

.flows span {
  color: #aaa;
}

.flows i {
  margin: 0 5px;
}

.flows span.current {
  color: #047bf8;
}

.flows span.before {
  color: #047bf88c;
}

.unfold {
  font-size: 12px;
  color: #047bf8;
  text-decoration: underline;
  margin-top: 10px;
  cursor: pointer;
  padding-left: 100px;
}

.user-info .avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  overflow: hidden;
  margin-right: 20px;
}

.user-info .name {
  font-size: 14px;
  margin-bottom: 2px;
}

.user-info .avatar img {
  width: 100%;
  height: 100%;
}

.user-info .date {
  text-align: right;
}

.user-info {
  border-bottom: 1px solid #eee;
  padding-bottom: 16px;
  font-size: 12px;
}

.infos-wrapper {
  display: flex;
  justify-content: space-between;
  position: relative;
}

#sr-form >>> label.el-form-item__label,
#sr-form >>> .el-radio__label {
  font-size: 12px !important;
}

/deep/.ql-editor {
  min-height: 100px;
}

/deep/.ql-formats {
  line-height: 0;
}

.times {
  /* padding-left: 100px; */
  display: flex;
  margin-top: 10px;
}

.times div {
  flex: 1;
  max-width: 200px;
  font-size: 12px;
  color: #999;
  /* text-align: center; */
}

.preview-steps {
  font-size: 12px;
  color: #888;
  display: flex;
  flex-wrap: wrap;
  line-height: 1.5em;
  margin-top: 10px;
}

.preview-steps .arrow {
  margin: 0 4px;
}

.timeline-cell {
  position: relative;
}

.timeline-cell .line-y {
  position: absolute;
  bottom: -6px;
  top: 34px;
  left: 49px;
  background-color: #047bf8;
  width: 1px;
  z-index: 99;
}

.timeline-cell .node {
  position: absolute;
  top: 6px;
  left: 0;
  width: 100px;
  height: 28px;
  line-height: 28px;
  border: 1px solid #047bf8;
  background-color: #aac9eb6e;
  color: #047bf8;
  font-size: 12px;
  text-align: center;
  z-index: 999;
  border-radius: 4px;
}

.timeline-cell .content {
  margin-left: 120px;
  padding-bottom: 10px;
  padding-top: 6px;
  border-bottom: 1px solid #f0f0f0;
}

.timeline-cell .name-info {
  line-height: 28px;
}

.timeline-cell .content .attachements {
  padding-top: 10px;
  font-size: 12px;
}

.timeline-cell .content .attachements .file-item {
  margin-top: 10px;
}

.timeline-cell .content .attachements .file-item i {
  margin-right: 5px;
}

.timeline-cell .content .attachements .file-item .preview {
  opacity: 0;
  margin-left: 40px;
}

.timeline-cell .content .attachements .file-item:hover .preview {
  opacity: 1;
}

.timeline-cell .desc {
  font-size: 14px;
  line-height: 1.5;
}

/deep/.timeline-cell .desc p {
  margin-bottom: 0;
}

/deep/.timeline-cell .desc img {
  max-width: 100px;
}

#sr-form .el-input,
#sr-form .el-select {
  width: 100% !important;
}

.evalaute-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.evalaute-wrapper .el-form-item {
  width: 48%;
}

.flex-row {
  align-items: center;
}

.desc-img {
  display: flex;
  flex-wrap: wrap;
  margin-top: 6px;
  margin-bottom: 6px;
}

.flow-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.font-bold {
  font-weight: bold !important;
}

.video-container {
  width: 40px;
  height: 40px;
  position: relative;
  border: 1px solid #f0f0f0;
  margin-right: 4px;
}

.video-container div {
  background: rgba(0, 0, 0, 0.7);
  width: 40px;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #fff;
}

/deep/.video-container video {
  width: 100%;
  height: 100%;
}

.commentcontainer {
  border: 1px solid #dde2ec;
  border-radius: 4px;
}

.prod-container {
  padding: 0 16px;
}

.prod-container .name {
  border-top: 1px dashed #dde2ec;
  padding-top: 5px;
}

/deep/.commentcontainer .ql-toolbar.ql-snow {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0 !important;
}

/deep/.commentcontainer .ql-container.ql-snow {
  border-bottom: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0 !important;
}

.btn-option {
  display: flex;
  flex-direction: column;
}

.timeline-cell .node.info {
  color: #fff;
  border-color: #00bcd4;
  background: #00bcd4;
}
/deep/.step-title {
  line-height: 1.5em;
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;
}
</style>
